import {
  containsLowerCase,
  containsNumber,
  containsSpecialChar,
  containsUpperCase,
  isEmailValid,
} from 'shared/utils/strUtil';
import {
  MINIMUM_PASSWORD_LENGTH,
  PASSWORD_VALIDATION_RESULT_STRINGS,
  USERNAME_VALIDATION_RESULT_STRINGS,
} from 'users/constants/usersConstants';
import currenciesMap from 'app/contexts/Currency/assets/currencies_list.json';

const currenciesArr = Object.keys(currenciesMap);
export const isUsernameValid = (username) => {
  let validResult = true;
  const resultStrings = [];

  if (!isEmailValid(username)) {
    validResult = false;
    resultStrings.push(USERNAME_VALIDATION_RESULT_STRINGS.INVALID_USERNAME);
  }

  return {
    validResult,
    resultStrings,
  };
};

export const isPasswordValid = (password) => {
  let validResult = true;
  const resultStrings = [];

  if (!containsSpecialChar(password)) {
    validResult = false;
    resultStrings.push(PASSWORD_VALIDATION_RESULT_STRINGS.INVALID_NO_SPECIAL_CHAR);
  }

  if (!containsLowerCase(password)) {
    validResult = false;
    resultStrings.push(PASSWORD_VALIDATION_RESULT_STRINGS.INVALID_NO_LOWERCASE_CHAR);
  }

  if (!containsUpperCase(password)) {
    validResult = false;
    resultStrings.push(PASSWORD_VALIDATION_RESULT_STRINGS.INVALID_NO_UPPERCASE_CHAR);
  }

  if (password.length <= MINIMUM_PASSWORD_LENGTH) {
    validResult = false;
    resultStrings.push(PASSWORD_VALIDATION_RESULT_STRINGS.INVALID_LENGTH);
  }

  if (!containsNumber(password)) {
    validResult = false;
    resultStrings.push(PASSWORD_VALIDATION_RESULT_STRINGS.INVALID_NO_NUMBER);
  }

  return {
    validResult,
    resultStrings,
  };
};

export const isValidCurrency = (currency) => {
  return currenciesArr.includes(currency);
};
